import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RsDynamicMatAutocompleteComponent } from './rs-dynamic-mat-autocomplete.component';
import { MatError, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { RsSharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MatAutocompleteTriggerEnforceSelectionDirective
} from '../../directives/mat-autocomplete-trigger-enforce-selection/mat-autocomplete-trigger-enforce-selection.directive';

@NgModule({
  declarations: [RsDynamicMatAutocompleteComponent],
  exports: [RsDynamicMatAutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatAutocompleteModule,
    MatError,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatLabel,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    RsSharedModule,
    TranslateModule,
    MatAutocompleteTriggerEnforceSelectionDirective
  ]
})
export class RsDynamicMatAutocompleteModule {
}
